import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import type { Role } from "@/composables/role-manager";
import RoleEditor from "@/components/Roles/RoleEditor.vue";
import { useHotKeys } from "./hotkeys";

export const useEditRoleDialog = (
    opts: {
        withHotKey: boolean;
    } = {
        withHotKey: true,
    }
) => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));

    if (opts.withHotKey) {
        const { addHotKey } = useHotKeys();

        addHotKey(
            "n r",
            (e) => {
                if (!isVisible.value) {
                    e.preventDefault();
                    open();
                }
            },
            "Open new role dialog."
        );
    }

    const open = (role?: Role) => {
        dialogRef.value = dialog.open(RoleEditor, {
            props: {
                header: role ? "Edit role" : "New role",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            data: role,
        });
    };

    return { open, isVisible };
};
